import { useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { USER_ROLES } from '../../utils/constant';
import { CommonLayout, CommonLayoutForInvestor } from '../commonComponents';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import ProductDetails from '../dashboard/product-details';
import CategoryWiseActionItems from '../investorOverview/mutualFund/CategoryWiseActionItems';
import DirectEquity from '../investorOverview/directEquity';
import PMS from '../investorOverview/pms';
import Alternates from '../investorOverview/alternates';
import Bonds from '../investorOverview/bonds';
import ExploreMutualFund from '../investorOverview/exploreMutualFund';
import IndividualFundDetails from '../investorOverview/fundDetails';
import SelectedCategorySchemes from '../investorOverview/exploreMutualFund/SelectedCategorySchemes';
import SIPCalculator from '../investorOverview/exploreMutualFund/SIPCalculator';
import GoalCalculator from '../investorOverview/exploreMutualFund/GoalCalculator';


const routerList = [
    {
        name: 'Product Mutual Funds',
        path: "mutual-fund",
        component: ProductDetails,
    },
    {
        name: ' Explore MF Product Mutual Funds',
        path: "mutual-fund/explore",
        component: ExploreMutualFund,
    },
    {
        name: 'SIP Calculator',
        path: 'mutual-fund/explore/sip-calculator',
        component: SIPCalculator
    },
    {
        name: 'Goal Calculator',
        path: 'mutual-fund/explore/goal-calculator',
        component: GoalCalculator
    },
    {
        name: 'Selected Category Funds',
        path: 'mutual-fund/explore/selected-category-funds',
        component: SelectedCategorySchemes,
    },
    {
        name: 'Explore MF Individual Fund Dashboard',
        path: 'mutual-fund/explore/selected-category-funds/:individualFundId',
        component: IndividualFundDetails,
    },
    {
        name: 'Individual Fund Dashboard',
        path: 'mutual-fund/explore/:individualFundId',
        component: IndividualFundDetails,
    },
    {
        name: 'Category Wise Breakup',
        path: 'mutual-fund/category-wise-breakup',
        component: CategoryWiseActionItems
    },
    {
        name: 'Product Direct Equity',
        path: "direct-equity",
        component: DirectEquity,
    },
    {
        name: 'Product PMS',
        path: "pms",
        component: PMS,
    },
    {
        name: 'Product Debt',
        path: "debt",
        component: Bonds,
    },
    {
        name: 'Product Alternates',
        path: "alternates",
        component: Alternates,
    },

]

function ProductRoutes(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            {
                routerList.map((item, index) => <Route
                    exact
                    key={index}
                    path={`${path}/${item.path}`}
                    component={item.component}
                />)
            }
        </Switch>
    );
}
export default function ProductsRouter(): JSX.Element {
    const { role } = useSelector((store: RootStateType) => store.auth);
    return (
        <>

            <CommonLayout>
                <ProductRoutes />
            </CommonLayout>


        </>
    )
}